import React, { createContext, useContext, useMemo, useState, useCallback } from "react";

const initialState = {
    selectedItem: null,
    isChanged: false,
};

const UserGuideContext = createContext(null);

export function UserGuideProvider({ children }) {
    const [state, setState] = useState(initialState);

    const handleUserGuideState = useCallback((payload) => {
        setState((prev) => ({
            ...prev,
            ...payload,
        }));
    }, []);

    const resetUserGuideState = useCallback(() => {
        setState(initialState);
    }, []);

    const value = useMemo(() => ({
        state,
        handleUserGuideState,
        resetUserGuideState,
    }), [state, handleUserGuideState, resetUserGuideState]);

    return (
        <UserGuideContext.Provider value={value}>
            {children}
        </UserGuideContext.Provider>
    );
}

export function useUserGuide() {
    const ctx = useContext(UserGuideContext);
    if (!ctx) {
        throw new Error("useUserGuide must be used within a UserGuideProvider");
    }
    return ctx;
}


